const breakpoints = {
  base: "0em",
  xsm: "23em", // 368px
  ssm: "25em", // 400px
  ssm2: "26.25em", // 420px
  sm: "30em", // 480px
  smd: "36em", // 576px
  md: "48em", // 768px
  mxd: "48.01em", // 769px
  lg: "62em", // 992px
  lg2: "64em", // 1024px
  xl: "80em", // 1280px
  xxl: "96em", // 1536px
  xxxl: "120em", // 1920px
}

export default breakpoints
